import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import "./EditPagamento.css";
import { Button, Input } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import * as links from "../../../utils/links";
import axios from "axios";
import question_icon from "../../../assets/images/question.png";
import { SERVIDOR_URL } from "../../../utils/constants";

const EditPagamento = (props) => {
  const location = useLocation();
  let navigate = useNavigate();

  const maquinaInfos = (location.state as any);

  const { authInfo, setNotiMessage, setDataUser } = useContext<any>(AuthContext);
  const { dataUser } = authInfo;

  const [data, setData] = useState<any>({
    nome: maquinaInfos?.nome ?? "",
    descricao: maquinaInfos?.descricao ?? "",
    estoque: Number(maquinaInfos?.estoque) ?? 0,
    estoque1: Number(maquinaInfos?.estoque1) ?? 0,
    estoque2: Number(maquinaInfos?.estoque2) ?? 0,
    estoque3: Number(maquinaInfos?.estoque3) ?? 0,
    estoque4: Number(maquinaInfos?.estoque4) ?? 0,
    estoque5: Number(maquinaInfos?.estoque5) ?? 0,
    estoque6: Number(maquinaInfos?.estoque6) ?? 0,
    nomeEstoque1: maquinaInfos?.nomeestoque1 ?? '',
    nomeEstoque2: maquinaInfos?.nomeestoque2 ?? '',
    nomeEstoque3: maquinaInfos?.nomeestoque3 ?? '',
    nomeEstoque4: maquinaInfos?.nomeestoque4 ?? '',
    nomeEstoque5: maquinaInfos?.nomeestoque5 ?? '',
    nomeEstoque6: maquinaInfos?.nomeestoque6 ?? '',
    store_id: Number(maquinaInfos?.store_id) ?? 0,
    maquininha_serial: String(maquinaInfos?.maquininha_serial),
    valorDoPulso: maquinaInfos?.pulso ?? 0,
  });
  const [errors, setErrors] = useState<any>({});

  const [isLoading, setIsLoading] = useState<any>(false);

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();
  useEffect(()=>{
    console.log(maquinaInfos)
  },[])

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {
    // check require
    let errorsTemp: any = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }
    if (data.descricao.trim() === "") {
      errorsTemp.descricao = "Este campo é obrigatório";
    }

    if (data.valorDoPulso < 0) {
      errorsTemp.valorDoPulso = "Este campo é obrigatório";
    }
    if (data.estoque < 0) {
      errorsTemp.estoque = "Estoque é obrigatório";
    }
    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios
      .put(
        `${SERVIDOR_URL}/maquina-cliente`,
        {
          id,
          nome: data.nome,
          descricao: data.descricao,
          estoque: Number(data.estoque),
          estoque1: Number(data.estoque1),
          estoque2: Number(data.estoque2),
          estoque3: Number(data.estoque3),
          estoque4: Number(data.estoque4),
          estoque5: Number(data.estoque5),
          estoque6: Number(data.estoque6),
          nomeestoque1: data.nomeEstoque1,
          nomeestoque2: data.nomeEstoque2,
          nomeestoque3: data.nomeEstoque3,
          nomeestoque4: data.nomeEstoque4,
          nomeestoque5: data.nomeEstoque5,
          nomeestoque6: data.nomeEstoque6,
          store_id: String(data.store_id),
          maquininha_serial: String(data.maquininha_serial),
          valorDoPulso: data.valorDoPulso,
        },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        navigate(links.DASHBOARD_FORNECEDOR);
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser.key === 'ADMIN') {
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          } else {
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        } else if (err.response.status === 400) {
          setNotiMessage({
            type: "error",
            message: `${err.response.data.error}`,
          });
          setErrors((prev) => ({
            ...prev,
            nome: "Já existe uma máquina com esse nome",
          }));
        } else {
          setNotiMessage({
            type: "error",
            message: "Um erro ocorreu",
          });
        }
      });
  };

  return (
    <div className="PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="PagamentosSearch_header">
        <div className="PagamentosSearch_header_left">
          <div className="Dashboard_staBlockTitle">Editar Máquina</div>
        </div>

        <Button
          className="EditPagamentos_header_back"
          onClick={() => {
            navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${id}`, {
              state: (location.state as any),
            });
          }}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Update_Pagamento_content">
        <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="nome">
            Nome:
          </label>
          <Input
            placeholder={"Máquina 1"}
            value={data.nome}
            id="nome"
            type="text"
            name="nome"
            autoComplete="nome"
            onChange={(event) => {
              handleChange("nome", event.target.value);
            }}
            className={`${!!errors.nome ? "Update_Pagamento_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Update_Pagamento_itemFieldError">{errors.nome}</div>
          )}
        </div>
        <div className="Update_Pagamento_itemField">
          <label
            className="Update_Pagamento_itemFieldLabel"
            htmlFor="descricao"
          >
            Descricão:
          </label>
          <Input
            placeholder={"Máquina da padaria de juquinha"}
            value={data.descricao}
            id="descricao"
            type="text"
            name="descricao"
            autoComplete="descricao"
            onChange={(event) => {
              handleChange("descricao", event.target.value);
            }}
            className={`${!!errors.descricao ? "Update_Pagamento_inputError" : ""
              }`}
          />
          {errors.descricao && (
            <div className="Update_Pagamento_itemFieldError">
              {errors.descricao}
            </div>
          )}
        </div>

        <div className="Update_Pagamento_itemField">
          <label
            className="Update_Pagamento_itemFieldLabel"
            htmlFor="store_id"
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>Store_id:</span>
            <Button
              className="EditPagamentos_header_HelpPage"
              onClick={() => {
                navigate(links.HELP_PAGE, {
                  state: {
                    ...(location.state as any),
                    redirect_url: `${links.EDIT_FORNECEDOR_CANAIS}/${id}`,
                  },
                });
              }}
              disabled={isLoading}
            >
              <img
                className="Edit_Pagamento_Icon"
                src={question_icon}
                alt="question icon"
              />
            </Button>
          </label>
          <Input
            placeholder={"12345678"}
            value={data.store_id}
            id="store_id"
            name="store_id"
            min={0}
            autoComplete="store_id"
            onChange={(event) => {
              handleChange("store_id", event.target.value);
            }}
            className={`${!!errors.store_id ? "Update_Pagamento_inputError" : ""
              }`}
          />
          {errors.store_id && (
            <div className="Update_Pagamento_itemFieldError">
              {errors.store_id}
            </div>
          )}
        </div>
        <div className="AddMachine_itemField">
          <label className="AddMachine_itemFieldLabel" htmlFor="maquininha_serial">
            Maquininha_serial:
          </label>
          <Input
            placeholder={""}
            value={data.maquininha_serial}
            id="maquininha_serial"
            name="maquininha_serial"
            min={0}
            autoComplete="maquininha_serial"
            onChange={(event) => {
              handleChange("maquininha_serial", event.target.value);
            }}
            className={`${!!errors.maquininha_serial ? "AddMachine_inputError" : ""}`}
          />
          {errors.maquininha_serial && (
            <div className="AddMachine_itemFieldError">{errors.maquininha_serial}</div>
          )}
        </div>
        <div className="Update_Pagamento_itemField">
          <label
            className="Update_Pagamento_itemFieldLabel"
            htmlFor="valorDoPulso"
          >
            Valor Do Pulso R$:
          </label>
          <Input
            placeholder={"1.50"}
            value={data.valorDoPulso}
            id="valorDoPulso"
            type="number"
            name="valorDoPulso"
            autoComplete="valorDoPulso"
            onChange={(event) => {
              handleChange("valorDoPulso", event.target.value);
            }}
            className={`${!!errors.valorDoPulso ? "Update_Pagamento_inputError" : ""
              }`}
          />
          {errors.valorDoPulso && (
            <div className="Update_Pagamento_itemFieldError">
              {errors.valorDoPulso}
            </div>
          )}
        </div>
        {/* <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="estoque">
            Estoque:
          </label>
          <Input
            placeholder={"1.50"}
            value={data.estoque}
            id="estoque"
            type="number"
            name="estoque"
            autoComplete="estoque"
            onChange={(event) => {
              handleChange("estoque", event.target.value);
            }}
            className={`${
              !!errors.estoque ? "Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.estoque && (
            <div className="Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div> */}
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque Geral (0):
          </label>
          <Input
            placeholder={"1.50"}
            value={data.estoque}
            id="estoque"
            type="number"
            name="estoque"
            autoComplete="estoque"
            onChange={(event) => {
              handleChange("estoque", event.target.value);
            }}
            className={`${!!errors.estoque ? "Admin_Update_Pagamento_inputError" : ""
              }`}
          />
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (1):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 1"}
                value={data.nomeEstoque1}
                id="nomeEstoque1"
                type="text"
                name="nomeEstoque1"
                autoComplete="nomeEstoque1"
                onChange={(event) => {
                  handleChange("nomeEstoque1", event.target.value);
                }}
                className={`${!!errors.nomeEstoque1 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque1}
                id="1"
                type="number"
                name="estoque1"
                autoComplete="estoque1"
                onChange={(event) => {
                  handleChange("estoque1", event.target.value);
                }}
                className={`${!!errors.estoque1 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>

          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (2):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 2"}
                value={data.nomeEstoque2}
                id="nomeEstoque2"
                type="text"
                name="nomeEstoque2"
                autoComplete="nomeEstoque2"
                onChange={(event) => {
                  handleChange("nomeEstoque2", event.target.value);
                }}
                className={`${!!errors.nomeEstoque2 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque2}
                id="estoque2"
                type="number"
                name="estoque2"
                autoComplete="estoque2"
                onChange={(event) => {
                  handleChange("estoque2", event.target.value);
                }}
                className={`${!!errors.estoque2 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (3):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 3"}
                value={data.nomeEstoque3}
                id="nomeEstoque3"
                type="text"
                name="nomeEstoque3"
                autoComplete="nomeEstoque3"
                onChange={(event) => {
                  handleChange("nomeEstoque3", event.target.value);
                }}
                className={`${!!errors.nomeEstoque3 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque3}
                id="estoque3"
                type="number"
                name="estoque3"
                autoComplete="estoque3"
                onChange={(event) => {
                  handleChange("estoque3", event.target.value);
                }}
                className={`${!!errors.estoque3 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (4):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 4"}
                value={data.nomeEstoque4}
                id="nomeEstoque4"
                type="text"
                name="nomeEstoque4"
                autoComplete="nomeEstoque4"
                onChange={(event) => {
                  handleChange("nomeEstoque4", event.target.value);
                }}
                className={`${!!errors.nomeEstoque4 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque4}
                id="estoque4"
                type="number"
                name="estoque4"
                autoComplete="estoque4"
                onChange={(event) => {
                  handleChange("estoque4", event.target.value);
                }}
                className={`${!!errors.estoque4 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (5):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 5"}
                value={data.nomeEstoque5}
                id="nomeEstoque5"
                type="text"
                name="nomeEstoque5"
                autoComplete="nomeEstoque5"
                onChange={(event) => {
                  handleChange("nomeEstoque5", event.target.value);
                }}
                className={`${!!errors.nomeEstoque5 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque5}
                id="estoque5"
                type="number"
                name="estoque5"
                autoComplete="estoque5"
                onChange={(event) => {
                  handleChange("estoque5", event.target.value);
                }}
                className={`${!!errors.estoque5 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque (6):
          </label>
          <div className="row">
            <div className="col-md-8">
              <Input
                placeholder={"Nome do estoque 6"}
                value={data.nomeEstoque6}
                id="nomeEstoque6"
                type="text"
                name="nomeEstoque6"
                autoComplete="nomeEstoque6"
                onChange={(event) => {
                  handleChange("nomeEstoque6", event.target.value);
                }}
                className={`${!!errors.nomeEstoque6 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
            <div className="col-md-4">
              <Input
                placeholder={"1.50"}
                value={data.estoque6}
                id="estoque6"
                type="number"
                name="estoque6"
                autoComplete="estoque6"
                onChange={(event) => {
                  handleChange("estoque6", event.target.value);
                }}
                className={`${!!errors.estoque6 ? "Admin_Update_Pagamento_inputError" : ""
                  }`}
              />
            </div>
          </div>
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>

        <Button
          className="Update_Pagamento_saveBtn"
          onClick={() => {
            if (!isLoading) onSave();
          }}
          disabled={isLoading}
        >
          SALVAR ALTERAÇÕES
        </Button>
        <Button
          className="Update_Pagamento_deleteBtn"
          onClick={() => {
            navigate(`${links.DELETE_FORNECEDOR}/${id}`, {
              state: (location.state as any),
            });
          }}
          disabled={isLoading}
        >
          EXCLUIR MÁQUINA
        </Button>
      </div>
    </div>
  );
};

export default EditPagamento;
